var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.classes,attrs:{"role":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('Icon',{staticClass:"singularity-canvas-button__icon",attrs:{"icon":_vm.icon,"size":"14"}}),_c('span',{staticClass:"singularity-canvas-button__text"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }